import { ecommerceConfig } from "../config/ecommerce";

type Palette = { [k: string]: any };

const palette: Palette = ecommerceConfig.ecommercePalette.materialUi;

export default palette;
